import type DxfArrayScanner from '../DxfArrayScanner';
import { ScannerGroup } from '../DxfArrayScanner';
import { createParser, DXFParserSnippet } from '../shared/parserGenerator';
import { LayoutSnippets } from './layout';
import { CommonObjectSnippets } from './common';
import { PlotSettingsSnippets } from './plotSettings';
import { DictionarySnippets } from './dictionary';
import { createObjectTree } from './treefy';
import { classify } from '../../utils';

const ObjectSchemas: Record<string, DXFParserSnippet[]> = {
    LAYOUT: LayoutSnippets,
    PLOTSETTINGS: PlotSettingsSnippets,
    DICTIONARY: DictionarySnippets,
};

export default function parseObjects(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const result = [] as any[];
    let current = curr; // create a new local variable

    while (current.code !== 0 || !['EOF', 'ENDSEC'].includes(current.value)) {
        const objectName = current.value as string;
        const snippets = ObjectSchemas[objectName];

        if (current.code === 0 && snippets?.length) {
            const parser = createParser([...CommonObjectSnippets, ...snippets]);
            const parsedObject = { name: objectName } as any;

            current = scanner.next();

            if (parser(current, scanner, parsedObject)) {
                result.push(parsedObject);
                current = scanner.peek();
            } else {
                current = scanner.next();
            }
        } else {
            current = scanner.next();
        }
    }

    return {
        byName: classify(result, ({ name }) => name),
        byTree: createObjectTree(result),
    };
}
